export type VideoEmbedProvider = 'youtube' | 'vimeo';

export interface VideoEmbedProviderConfig {
  provider: VideoEmbedProvider;
  inputId: string;
  channelInitialsFallback: string;
  urlControlName: 'youtubeUrl' | 'vimeoUrl';
  requestTokenPrefix: string;
  isUrlValid: (url: string) => boolean;
  buildOEmbedEndpoint: (url: string) => string;
}

function isYoutubeUrl(url: string): boolean {
  try {
    const hostname = new URL(url).hostname.toLowerCase();
    return hostname.includes('youtube.com') || hostname.includes('youtu.be');
  } catch {
    return false;
  }
}

function isVimeoUrl(url: string): boolean {
  try {
    return new URL(url).hostname.toLowerCase().includes('vimeo.com');
  } catch {
    return false;
  }
}

export const VIDEO_EMBED_PROVIDER_CONFIG: Record<VideoEmbedProvider, VideoEmbedProviderConfig> = {
  youtube: {
    provider: 'youtube',
    inputId: 'contentYoutubeUrl',
    channelInitialsFallback: 'YT',
    urlControlName: 'youtubeUrl',
    requestTokenPrefix: 'youtube-oembed',
    isUrlValid: isYoutubeUrl,
    buildOEmbedEndpoint: (url) => `https://www.youtube.com/oembed?url=${encodeURIComponent(url)}&format=json`,
  },
  vimeo: {
    provider: 'vimeo',
    inputId: 'contentVimeoUrl',
    channelInitialsFallback: 'VI',
    urlControlName: 'vimeoUrl',
    requestTokenPrefix: 'vimeo-oembed',
    isUrlValid: isVimeoUrl,
    buildOEmbedEndpoint: (url) => `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`,
  },
};
